<template>
  <div class="mgt-10px VueTables">
    <div class="table-responsive">
      <table class="VueTables__table table is-striped-reverse
                    is-bordered is-fullwidth">
        <thead>
        <th>
          <div class="right">{{ $t('detail.commande.repartitionsTva.base') }}</div>
        </th>
        <th>
          <div class="right">{{ $t('detail.commande.repartitionsTva.rate') }}</div>
        </th>
        <th>
          <div class="right">{{ $t('detail.commande.repartitionsTva.tva') }}</div>
        </th>
        </thead>
        <tbody>
        <tr v-for="(item, index) in repartitionsTva"
            :key="index">
          <td class="right" v-if="item.tauxTva !== '0.00'">{{ item.totalHt }}</td>
          <td class="right" v-if="item.tauxTva !== '0.00'">{{ item.tauxTva }} %</td>
          <td class="right" v-if="item.tauxTva !== '0.00'">{{ item.totalTva }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    repartitionsTva: {
      type: Array,
      required: true,
    },
  },
};
</script>
